import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StatusCard from "./StatusCard";
import GridLoadingSpinner from "../GridLoadingSpinner/GridLoadingSpinner";
// import { ROUTES } from "../../constants";

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(2),
    borderRadius: "20px",
    backgroundColor: "#ffffff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.12)",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#00005C",
    marginBottom: "16px",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const transformDelayDataToComponentFormat = (delayData) => {
  if (!delayData) return [];

  return [
    {
      label: "Delayed Performer",
      value: delayData.delayed_performer_count || 0,
      sequence: 1,
    },
    {
      label: "Delayed Approver",
      value: delayData.delayed_approver_count || 0,
      sequence: 2,
    },
    {
      label: "Total Delays",
      value: delayData.total_delayed_count || 0,
      sequence: 3,
    },
  ];
};

const DelayStatus = ({ dashboardDelayStatusData, loader }) => {
  const classes = useStyles();
  const history = useHistory();
  const [delayStatusData, setDelayStatusData] = useState([]);

  useEffect(() => {
    const transformedRows = transformDelayDataToComponentFormat(
      dashboardDelayStatusData
    );
    setDelayStatusData(transformedRows);
  }, [dashboardDelayStatusData]); // Re-fetch when date filter changes

  return (
    <Grid item xs={12} className={classes.section}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Delay Status
      </Typography>
      {loader ? (
        <Box className={classes.loader}>
          <GridLoadingSpinner />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {delayStatusData.map((item) => (
            <Grid item xs={12} sm={6} md={6} key={item.label}>
              <StatusCard {...item} history={history} />
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};
DelayStatus.propTypes = {
  dashboardDelayStatusData: PropTypes.shape({
    delayed_performer_count: PropTypes.number,
    delayed_approver_count: PropTypes.number,
    total_delayed_count: PropTypes.number,
  }),
  loader: PropTypes.bool,
};

export default DelayStatus;
